import { useAuth } from '@/hooks/useAuth';
import { MerchantWarehousesTab } from '@/features/merchants/tabs/MerchantWarehousesTab';

/**
 * Merchant-portal "Pickup Locations" page. Reuses the same full manager the admin uses on a
 * merchant's detail page (list + Add + Edit + Export), scoped to the logged-in merchant's own id
 * (for both a merchant main-user and a sub-user, `user.id` is the parent merchant id). Delete is
 * hidden because it is admin-only on the backend — a merchant deactivates a location by editing it
 * and unchecking "Active".
 */
export function MerchantPickupLocationsPage() {
  const { user } = useAuth();
  const merchantId = user?.kind === 'merchant' ? user.id : undefined;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Pickup Locations</h1>
        <p className="text-slate-500 text-sm mt-1">
          Add and manage the addresses couriers pick your shipments up from (and the RTO return address).
        </p>
      </div>
      {merchantId
        ? <MerchantWarehousesTab merchantId={merchantId} canDelete={false} />
        : <div className="text-sm text-slate-400">Unable to determine your account. Please sign in again.</div>}
    </div>
  );
}
